import fairMainSlideshow from "./js/widgets/fairMainSlideshow.js";
import fairMultiScheduleFeature from "./js/widgets/fairMultiScheduleFeature.js";
import fairSecondarySlideshow from "./js/widgets/fairSecondarySlideshow.js";
import fairSeoWidget from "./js/widgets/fairSeoWidget.js";
import fairSignupModule from "./js/widgets/fairSignupModule.js";
import fairGridGalleryLarge from "./js/widgets/fairGridGalleryLarge.js";
import cssSponsors from "./js/widgets/cssSponsors.js";

import customSocialIcons from "./js/utils/customSocialIcons.js";
import featureLineUp from "./js/utils/featureLineUp.js";

import { themeController } from "./js/ThemeControllers.js";
import splashPage from "./js/utils/splashPage.js";
import "./js/localjs.js";

$(document).ready(function () {
  $(body).css("opacity", "0");
  splashPage(themesConfig);
  themeController(themesConfig);
  cssSponsors();
  featureLineUp();

  if (window.location.pathname === "/") {
    fairMainSlideshow();
    fairMultiScheduleFeature();
    fairSeoWidget();
    fairSecondarySlideshow();
    fairSignupModule();
    customSocialIcons("fairSocialIcons", fairSocialIconsOpts, 4);
    fairGridGalleryLarge();
    let sponsors = $("#sponsorWidgetContainer");
    $(".sponsor-section").append(sponsors);
    $(".afterContent").remove();
  }
});
